export const getCurrentDomain = (): string => {
  const hostname = window.location.hostname;

  // Use production domain when testing locally
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'store.mypetgroomer.com.au';
  }

  return hostname;
};
